import React from 'react';

import Wrapper from '../__atoms/wrapper';

// loading the sass style fot the component
import css from './styles.module.scss';
/**
 * Molecule Navbar
 *
 * The navbar to be used in the top of the pages.
 */
function Navbar(props) {

  const {
    className = '',
    menu = {},
    pageSettings,
    ...other
  } = props;

  return (
    <Wrapper {...other}>
      <div className={css['navbar-wrapper'] + ' ' + className}>
        <strong>{pageSettings.title} - {menu.title}</strong><br/>
        <MenuList items={menu.items} />
      </div>
    </Wrapper>
  );
}

function MenuList (props) {
  const {
    items
  } = props;

  return (
    <ul className={css['menu-list-container']}>
      {
        items?.map(item => {
          return (
            <li key={item.title}>
              {
                item.action
                  ? <a href={item.action}>{item.title}</a>
                  : <span>{item.title}</span>
              }

              {
                item.children && (
                  <MenuList items={item.children} />
                )
              }
            </li>
          );
        })
      }
    </ul>
  );
}

export default Navbar;
